import { axiosReq } from "@/lib/axios";
import { DiscardedPostType } from "../../types";
import { useQuery } from "@tanstack/react-query";

export const useGetPublishedPosts = (start_date: string = "2025-02-20", end_date: string = "2025-02-27") => {
  const request = async (): Promise<
    {
      message: string,
      data: DiscardedPostType[],
    }> => {
    const response = await axiosReq.post('/api/approval/get-published-posts/',
      {
        start_date: start_date,
        end_date: end_date
      });
    return response.data;
  }

  const { data: publishedPosts, isLoading } = useQuery({
    queryKey: ["published-socials", start_date, end_date],
    queryFn: request
  });

  return { publishedPosts, isLoading }
}
